export interface ILocalizationContext {
  children: React.ReactNode;
}

export enum Locale {
  EN = 'en',
}
